export const electronAPI = window.electronApi;
